
import { Component, Vue, Prop } from 'vue-property-decorator';

import MessageItem from '../MessageItem/index.vue';
@Component({
  name: 'MessageList',
  components: {
    MessageItem,
  },
})
class MessageList extends Vue {
  @Prop({ default: [] }) msgList:any;
  @Prop({ default: () => {} }) styleConfig:any
  resendMsg(msg) {
    this.$emit('resendMsg', msg);
  }
  /**
   * 获取seq。用于解决大模型消息片段重新渲染时seq变化导致消息体重新渲染的问题。
   * 对于一般消息，使用 seq
   * 对于大模型消息片段，需要使用内部的 updateSeq
   * @param {*} item 消息数据
   */
  getKey(item) {
    // 不需要了。因为消息通路会更新，同一消息的消息片段的seq是一样的。
    // const largeModelMsgConf = item?.content?.largeModelMsgConf;
    // if (largeModelMsgConf) {
    //   return largeModelMsgConf.updateSeq;
    // }
    return item.seq;
  }
}
export default MessageList;
